import { createGlobalStyle } from 'styled-components'
import { VisuallyHiddenStyles } from './components/_styled/BootStrapGrid'

export const GlobalStyle = createGlobalStyle`
  html {
    font-size: 62.5%;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-smoothing: antialiased;
    font-weight: 400;
  }
  
  *, ::after, ::before {
    box-sizing: border-box;
  }

  body {
    font-family: 'Futura PT', 'Futura PT Fallback', Arial, Helvetica, sans-serif ;
    margin: 0;
    font-size: 1.7rem;
    line-height: 1.3;
    &.bodyMarginTopNone {
        margin-top: 0 !important;
    }
  }

  h1,h2,h3,h4,h5,h6 {
    margin: 0;
    letter-spacing: .1rem;
    font-family: 'Futura PT', 'Futura PT Fallback', Arial, Helvetica, sans-serif;
  }
  
  p {
    font-family: 'Futura PT', 'Futura PT Fallback', Arial, Helvetica, sans-serif;
  }
  // for chat
  .visually-hidden{
    ${VisuallyHiddenStyles};
  }

  .chat-iframe-wrap {
      top: auto !important;
  }
 
  button{
    font-family: inherit;
  }
  
  @media print {
      #talkable-offer, .ie-div-position-customer-chat {
          display: none !important;
      }
  }
  
  @media (max-width: 1279px) {
      #checkoutContainer #mainContent, #mainContent.pdpTabView {
          margin-top: 0;
      }
      .ie-chat-button-iframe-fixed-customer-chat {
          top: 56% !important;
      }
      .ie-div-position-customer-chat .button-iframe-wrap {
          z-index: 99 !important;
      }
      #attentive_creative {
          bottom: 100px !important;
      }
  }
  
  @media (min-width: 1280px) { 
    .ie-chat-button-iframe-fixed-customer-chat {
        right: 4px !important;
        bottom: 2% !important;
    }
  }
//  Chat CSS -- would not need all of this if chat button was set to right -- percentage is relative to the css set to left
  @media (min-width: 1120px) and (max-width: 1279px) {
      .ie-chat-button-iframe-fixed-customer-chat {
          left: 96.1% !important;
      }
  }
  @media (min-width: 1080px) and (max-width: 1119px) {
      .ie-chat-button-iframe-fixed-customer-chat {
          left: 95.8% !important;
      }
  }
  @media (min-width: 980px) and (max-width: 1079px) {
      .ie-chat-button-iframe-fixed-customer-chat {
          left: 95.4% !important;
      }
  }
  @media (min-width: 88px) and (max-width: 979px) {
      .ie-chat-button-iframe-fixed-customer-chat {
          left: 95% !important;
      }
  }
  @media (min-width: 780px) and (max-width: 879px) {
      .ie-chat-button-iframe-fixed-customer-chat {
          left: 94.4% !important;
      }
  }
  @media (min-width: 750px) and (max-width: 779px) {
      .ie-chat-button-iframe-fixed-customer-chat {
          left: 93.7% !important;
      }
  }
  @media (max-width: 749px) {
      .ie-chat-button-iframe-fixed-customer-chat {
          left: 93% !important;
      }
  }

  .futura-pt {
    font-family: 'Futura PT', sans-serif;
  }
  .futura-pt-bold {
    font-family: 'Futura PT Bold', sans-serif;
  }
`
